<template>
    <v-list
        two-line
        subheader
        v-if="lastViewedProductsTotal > 0"
        light
    >
        <v-subheader>{{ 'Last visited products' | translation }}</v-subheader>

        <v-list-tile
            v-for="product in products"
            :key="product.id"
            :to="$product.getProductRouteConfig(product)"
        >
            <v-list-tile-avatar
                size="55"
                tile
            >
                <img :src="product.images.default.small">
            </v-list-tile-avatar>
            <v-list-tile-content>
                <v-list-tile-title>
                    {{ product.attributes.de['product.name'] }}
                </v-list-tile-title>
                <v-list-tile-sub-title>
                    {{ getProductDescription(product) | striphtml }}
                </v-list-tile-sub-title>
                <v-list-tile-sub-title class="text-xs-right">
                    {{ 'from' | translation }} {{ getProductPrice(product) | currency }}
                </v-list-tile-sub-title>
            </v-list-tile-content>
        </v-list-tile>
    </v-list>
</template>

<script>
import Vue from 'vue';
import module from './store/lastViewedProducts';
import { mapState, mapActions } from 'vuex';

const moduleName = 'LastViewedProducts';

if (!Vue.$store.state[moduleName]) {
    Vue.$store.registerModule(moduleName, module);
}

export default {
    name: moduleName,
    created() {
        if (this.$localStorage.last_viewed_products_list.products) {
            const lastViewedProducts = this.$localStorage.last_viewed_products_list.products;
            this.loadLastViewedProducts(Object.keys(lastViewedProducts));
        }
    },
    computed: {
        ...mapState(moduleName, {
            lastViewedProducts: state => state.lastViewedProducts
        }),
        products() {
            const products = this.lastViewedProducts;
            const lastViewedProducts = this.$localStorage.last_viewed_products_list.products;
            const sortedProducts = products.sort((a, b) => (lastViewedProducts[b.id].date - lastViewedProducts[a.id].date));
            return sortedProducts;
        },
        lastViewedProductsTotal() {
            return this.lastViewedProducts.length;
        }
    },
    methods: {
        ...mapActions(moduleName, ['loadLastViewedProducts']),
        getProductPrice(product) {
            if (
                product.prices.default &&
                product.prices.default.original_price_inkl_vat
            ) {
                return product.prices.default.original_price_inkl_vat;
            }
        },
        getProductDescription(product) {
            let description = '';
            if (product.attributes && product.attributes.de) {
                if (product.attributes.de.hasOwnProperty('product.description.short')) {
                    description = product.attributes.de['product.description.short'];
                } else if (product.attributes.de.hasOwnProperty('product.description.long')) {
                    description = product.attributes.de['product.description.long'];
                }
            }
            return description;
        }
    }
};
</script>
